import {
  CREATED_AT,
  TEXT,
  UPDATED_AT,
  avatarUrl,
  displayName,
  remoteUserId,
  userEmail,
  userId,
} from '../constants/stringsAndFields';
import {isNotEmpty} from '../utils/arrays';
import {checkTableExists, insertData, selectData, updateData} from './common';
import {LOCAL_DEFAULT_USER_ID} from './userConstants';
import {runSqlCmd, exportDatabase} from './sqlOperations';

export const APP_USER_TABLE = 'AppUser';

export const userKeys = [
  userId,
  userEmail,
  displayName,
  avatarUrl,
  remoteUserId,
  CREATED_AT,
  UPDATED_AT,
];

const defaultUserIdSql = `'${LOCAL_DEFAULT_USER_ID}'`;

export const createAppUserTable = async tx => {
  await runSqlCmd(
    tx,
    `CREATE TABLE IF NOT EXISTS ${APP_USER_TABLE}(
      ${userId} ${TEXT} PRIMARY KEY NOT NULL,
      ${userEmail} ${TEXT},
      ${displayName} ${TEXT},
      ${avatarUrl} ${TEXT},
      ${remoteUserId} ${TEXT},
      ${CREATED_AT} ${TEXT},
      ${UPDATED_AT} ${TEXT});`,
  );
};

export const ensureDefaultUserRecord = async tx => {
  const rows = await selectData(
    tx,
    APP_USER_TABLE,
    userKeys,
    userId,
    LOCAL_DEFAULT_USER_ID,
    [],
    false,
    'LIMIT 1',
  );
  if (isNotEmpty(rows)) {
    return;
  }
  await runSqlCmd(
    tx,
    `INSERT OR IGNORE INTO ${APP_USER_TABLE} (${userId}, ${CREATED_AT}, ${UPDATED_AT})
     VALUES (${defaultUserIdSql}, CURRENT_TIMESTAMP, CURRENT_TIMESTAMP);`,
  );
};

export const upsertAppUser = async (tx, row) => {
  await insertData(tx, APP_USER_TABLE, userKeys, row);
  await exportDatabase(tx);
};

export const updateAppUser = async (tx, row) => {
  await updateData(tx, APP_USER_TABLE, row, userId);
  await exportDatabase(tx);
};

export const getAppUser = async (tx, uid = LOCAL_DEFAULT_USER_ID) => {
  const rows = await selectData(
    tx,
    APP_USER_TABLE,
    userKeys,
    userId,
    uid,
    [],
    false,
    'LIMIT 1',
  );
  return isNotEmpty(rows) ? rows[0] : null;
};

export const getAppUsers = async tx => {
  const rows = await selectData(tx, APP_USER_TABLE, userKeys);
  return isNotEmpty(rows) ? rows : [];
};

function escapeSqlLiteral(value) {
  if (value == null) {
    return '';
  }
  return String(value).replace(/'/g, "''");
}

export const deleteAppUser = async (tx, uid) => {
  const escaped = escapeSqlLiteral(uid);
  await runSqlCmd(
    tx,
    `DELETE FROM ${APP_USER_TABLE} WHERE ${userId} = '${escaped}';`,
  );
  await exportDatabase(tx);
};

export const checkAppUserTable = async tx => {
  return await checkTableExists(tx, APP_USER_TABLE);
};
